var _path;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgYogaRoom = function SvgYogaRoom(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 29.159a.5.5 0 0 1-.14.02H15a.5.5 0 0 1-.388-.185l-13.6-16.727a.5.5 0 0 1 .388-.815h19.454a7.715 7.715 0 0 1 12.171-8.769.5.5 0 0 1 .093.105c.05.026.096.063.136.108l11.88 13.345c.044.05.077.106.098.166A7.715 7.715 0 0 1 39.5 29.159Zm-.248-.98a.5.5 0 0 1 .138-.02 6.715 6.715 0 1 0-6.709-6.983c.127 2.768 2.515 4.983 5.453 4.983 2.978 0 5.392-2.276 5.457-5.098-.055-1.878-1.787-3.408-3.94-3.408-2.186 0-3.94 1.58-3.94 3.5 0 1.093 1.008 2 2.276 2 1.267 0 2.275-.907 2.275-2a.5.5 0 1 1 1 0c0 1.67-1.477 3-3.275 3-1.798 0-3.276-1.33-3.276-3 0-2.497 2.223-4.5 4.94-4.5 2.602 0 4.75 1.835 4.929 4.182a.502.502 0 0 1 .012.11l-.001.114.001.094a.503.503 0 0 1-.007.084c-.159 3.301-2.99 5.922-6.451 5.922a6.562 6.562 0 0 1-4.715-1.967.498.498 0 0 1-.275-.146L22.4 13.866a.498.498 0 0 1-.108-.17.5.5 0 0 1-.11-.095 7.737 7.737 0 0 1-.83-1.149h-18.9l12.787 15.727h24.013Zm2.695-14.015L32.508 3.56a.504.504 0 0 1-.044-.057.502.502 0 0 1-.09-.062 6.715 6.715 0 0 0-9.44 9.503c.042.047.072.098.092.153a.501.501 0 0 1 .095.077l8.583 8.93a7.81 7.81 0 0 1-.024-.925 6.094 6.094 0 0 1-.004-.234.5.5 0 0 1 .028-.167 7.715 7.715 0 0 1 10.243-6.614Zm-28.385 7.81a.5.5 0 0 1-.758.653L9.26 18.512a.5.5 0 1 1 .758-.652l3.545 4.115Z",
    fill: "#494949",
    fillRule: "nonzero"
  })));
};

export { SvgYogaRoom as ReactComponent };
export default "/_next/static/media/yoga_room.9580d24f.svg";